
import Icon from 'vux/src/components/icon/index.vue'

export default {
name: "send-email-success",
components: {
Icon
},
data(){
return {

}
},

}




// WEBPACK FOOTER //
// ./src/page/user/send-email-success.vue